<template>
  <div class="pa-4">
    <vue-table v-model="selectedRows" :data="autoData" :headers="autoHeaders" :loading.sync="loading"
               :props.sync="autoTableProps" show-select @change="onPagination">
      <template v-slot:filters="{perPage, props}">
        <v-row no-gutters>
          <v-col class="pa-2" cols="12" lg="1" md="2">
            <v-select v-model="props.length" :items="perPage" class="rounded-lg" dense hide-details label="تعداد"
                      outlined/>
          </v-col>

          <v-col class="pa-2" cols="12" lg="3" md="4">
            <v-text-field v-model="props.search" append-icon="mdi-magnify" class="rounded-lg" clearable dense
                          hide-details label="جستجو" outlined/>
          </v-col>

          <v-col class="pa-2" cols="12" lg="3" md="4">
            <v-select v-model="props.provider" :items="providerItems" :menu-props="{offsetY: true}"
                      class="rounded-lg" clearable dense label="فیلتر" outlined/>
          </v-col>
        </v-row>
      </template>

      <template v-slot:index="{item}">
        {{ (item.index + 1) + ((autoData.current_page - 1) * autoData.per_page) }}
      </template>

      <template v-slot:id={item}>
        {{ item.id }}
        <br>
        <p class="badge badge-info pa-1 ma-0">{{ item.provider | providers }}</p>
      </template>

      <template v-slot:phone={item}>
        <span v-if="item.number">{{ item.number.phone }}</span>
      </template>

      <!--      <template v-slot:payment={item}>-->
      <!--              <span :class="!!item.payment || !!item.renew ? 'badge-success' : 'badge-danger'" class="badge">-->
      <!--                {{ !!item.payment || !!item.renew ? 'تمدید اتوماتیک' : 'عدم تمدید' }}-->
      <!--              </span>-->
      <!--      </template>-->

      <!--      <template v-slot:renew={item}>-->
      <!--              <span :class="!!item.renew ? 'badge-success' : 'badge-danger'" class="badge">-->
      <!--                {{ !!item.renew ? 'فعال' : 'غیرفعال' }}-->
      <!--              </span>-->
      <!--      </template>-->
    </vue-table>
    <v-divider/>

    <v-card :disabled="!selectedRows.length" flat>
      <v-row no-gutters>
        <v-col class="pa-2" cols="12" lg="4" md="6">
          <custom-date-picker v-model="available_at" :auto-submit="false" :min="nowDateTimeString('-', 'date')" dense
                              format="YYYY-MM-DD" label="تاریخ‌های آنالیز" multiple nullable outlined type="date"
                              wrapper-class="rounded-lg"/>
        </v-col>

        <!--        <v-col class="pa-2" cols="12" lg="4" md="6">-->
        <!--          <custom-date-picker v-model="autoAdsEndTime" dense format="HH:mm:ss" input-class="end-time" label="ساعت شروع"-->
        <!--                              nullable outlined type="time" wrapper-class="rounded-lg"/>-->
        <!--        </v-col>-->

        <!--        <v-col class="pa-2" cols="12" lg="4" md="6">-->
        <!--          <v-text-field v-model="autoAdsCount" :min="1" class="rounded-lg" clearable dense hide-spin-buttons-->
        <!--                        label="تعداد ارتقا" oninput="if(Number(this.value) < this.min) this.value = 1" outlined-->
        <!--                        type="number"/>-->
        <!--        </v-col>-->

        <!--        <v-col class="pa-2" cols="12" lg="4" md="6">-->
        <!--          <v-select v-model="autoUpgradeType" :items="autoTypeItems" :menu-props="{offsetY: true}" class="rounded-lg"-->
        <!--                    dense label="نوع ارتقا" outlined/>-->
        <!--        </v-col>-->

        <!--        <v-fade-transition>-->
        <!--          <v-col v-if="autoUpgradeType === 'steps'" class="pa-2" cols="12" lg="4" md="6">-->
        <!--            <v-select v-model="stepsUpgrade" :items="stepsTypeItems" :menu-props="{offsetY: true}" class="rounded-lg"-->
        <!--                      dense label="نوع پله" outlined/>-->
        <!--          </v-col>-->
        <!--        </v-fade-transition>-->
      </v-row>

      <v-card-actions class="justify-end">
        <v-btn class="btn-accept" depressed @click="submit">
          <v-icon left>mdi-content-save-plus-outline</v-icon>
          ارسال
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import {Axios2} from "@/main";
import CustomDatePicker from "@/core/plugins/TitleRibbon/pages/pickers/custom-date-picker.vue";
import AutoPayDialog from "@/view/pages/ads/adsList/autoPayDialog.vue";

export default {
  name: "addToAnalyzer",

  components: {AutoPayDialog, CustomDatePicker},

  filters: {
    providers(input) {
      let obj = {
        divar: 'شخصی',
        sheypoor: 'شیپور',
        divar_shop: 'فروشگاهی',
        divar_real_estate: 'املاک',
        divar_service: '‌متخصص'
      }

      return obj[input]
    }
  },

  data() {
    return {
      loading: false,
      autoData: {},
      autoHeaders: [
        {value: 'index', text: 'ردیف', sortable: false, align: 'center'},
        {value: 'id', text: 'شناسه', sortable: false, align: 'center'},
        {value: 'phone', text: 'شماره', sortable: false, align: 'center'},
        {value: 'title', text: 'موضوع', sortable: false, align: 'center'},
        {value: 'created_at_p', text: 'تاریخ ارسال', sortable: false, align: 'center'},
        // {value: 'expire_at_p', text: 'تاریخ حذف', sortable: false, align: 'center'},
        // {value: 'payment', text: 'وضعیت تمدید', sortable: false, align: 'center'},
        // {value: 'renew', text: 'تمدید هوشمند', sortable: false, align: 'center'},
        // {value: 'action', text: 'مدیریت', sortable: false, align: 'center'},
      ],
      autoTableProps: {
        page: 1,
        length: 10,
        provider: undefined,
        search: undefined
      },
      selectedRows: [],
      autoUpgradeType: '',
      stepsUpgrade: '',
      autoAdsStartTime: null,
      autoAdsEndTime: null,
      autoAdsCount: 1,
      providerItems: [
        {value: 'divar', text: 'آگهی های شخصی'},
        {value: 'divar_shop', text: 'آگهی های فروشگاهی'},
        {value: 'divar_real_estate', text: 'آگهی های پنل املاک'},
        {value: 'divar_service', text: 'آگهی های متخصص'},
      ],
      // autoTypeItems: [
      //   {value: 'gradual', text: 'نردبان'},
      //   {value: 'steps', text: 'پله'},
      // ],
      // stepsTypeItems: [
      //   {value: 'craftsmen-0-1', text: '۱ روزه'},
      //   {value: 'craftsmen-0-3', text: '۳ روزه'},
      //   {value: 'craftsmen-0-7', text: '۷ روزه'},
      // ],
      available_at: []
    }
  },

  created() {
    this.getAutoAds()
  },

  // watch: {
  //   selectedRows(val) {
  //     if (!!val?.length) {
  //       this.autoAdsStartTime = this.nowDateTimeString('-', 'date')
  //       this.autoAdsEndTime = this.nowDateTimeString('-', 'time')
  //     } else {
  //       this.autoAdsStartTime = null
  //       this.autoAdsEndTime = null
  //     }
  //   }
  // },

  methods: {
    getAutoAds(params = this.autoTableProps) {
      this.loading = true

      Axios2.get('advertise/list/renew', {params})
        .then(({data}) => this.autoData = data)
        .finally(() => this.loading = false)
    },
    onPagination(e) {
      let props = {
        ...this.autoTableProps,
        ...e
      }

      this.getAutoAds(props)
    },
    submit() {
      this.loading = true

      Axios2.post('divar/analysis', {
          data: this.selectedRows.map(item => item.id),
          available_at: this.available_at
        }
      )
        .then(({data}) => this.$emit('fetch'))
        .finally(() => this.loading = false)
    }
  }
}
</script>

<style scoped>

</style>